import { render } from "./legoGridIndicator.vue?vue&type=template&id=1a1dd07e"
import script from "./legoGridIndicator.vue?vue&type=script&lang=js"
export * from "./legoGridIndicator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/layout/legoGrid/legoGridIndicator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a1dd07e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a1dd07e', __exports__)) {
    api.reload('1a1dd07e', __exports__)
  }
  
  module.hot.accept("./legoGridIndicator.vue?vue&type=template&id=1a1dd07e", () => {
    api.rerender('1a1dd07e', render)
  })

}


export default __exports__